const GameHeader = ({title}) => {
    return (
        <div className='titleHeader'>
            <h2>{title}</h2>
        </div>
    )
};

export default GameHeader;